<template lang="pug">
#app
  v-container(grid-list-xl, fluid)
    v-layout(row, wrap)
      v-flex(lg12)
        v-card
          v-toolbar(card, color='white')
            v-text-field.hidden-sm-and-down(flat, solo, prepend-icon='search', placeholder='Buscar notificação', v-model='search', hide-details)
            v-switch.mt-4(:false-value="0", :true-value="1", :color="filter.ativo ? 'success': ''", :label="filter.ativo ? 'Notificações ativas' : 'Notificações inativas'", v-model="filter.ativo")
            v-btn(color="bt-primary", :to="{ name: 'NotificacaoCadastro' }").white--text Cadastrar notificação
          v-divider
          v-card-text.pa-0
            v-data-table.elevation-1(:headers='headers', :search='search', :items='list', :rows-per-page-items="[25,50,75,{text:'Todos','value':-1}]", :loading="loading", :sort-by.sync="sortBy", :sort-desc.sync="sortDesc")
              template(slot='items', slot-scope='props')
                td.text-xs-left {{ props.item.id }}
                td.text-xs-left {{ props.item.titulo }}
                td.text-xs-left {{ props.item.descricao | descricao }}
                td.text-xs-left {{ props.item.data_hora | moment('DD/MM/YYYY [-] HH:mm') }}
                td.text-xs-left
                  v-chip(label, small, :color="['#318837', '#FF9800'][props.item.tipo]").text-uppercase.white--text.font-weight-bold {{ props.item.tipo | tipo }}
                td.text-xs-left
                  v-chip(label, small, :color="['#f44336', '#318837'][props.item.status]").text-uppercase.white--text.font-weight-bold {{ props.item.status | status }}
                td.text-xs-right.ma-0.pa-0
                  v-tooltip(top)
                    v-btn(slot="activator", flat, icon, fab, dark, color='bt-primary', small, :to="{ name: 'NotificacaoEditar', params: { id: props.item.id }}")
                      v-icon edit
                    span Editar
                  v-tooltip(top)
                    v-btn(slot="activator", flat, icon, fab, dark, :color="props.item.ativo ? 'red' : 'warning'", small, @click="changeAtivo(props.item)")
                      v-icon {{ props.item.ativo ? 'delete' : 'restore' }}
                    span {{ props.item.ativo ? 'Desativar' : 'Ativar' }}
                    
    v-dialog(v-model="dialogCategoriaFeedback", width="auto", scrollable, max-width="500px", persistent, v-if="dialogCategoriaFeedback")
      v-card
        v-card-title
          span.headline {{ categoriaFeedbackAux.id ? 'Editar Categoria' : 'Cadastrar Categoria' }}
          v-spacer
          v-tooltip(top)
            v-btn(icon, slot="activator", @click.native="$validator.pause();  categoriaFeedbackAux = {}; dialogCategoriaFeedback = false;")
              v-icon close
            span Fechar
        v-card-text
          form(@submit.prevent="salvar")
            v-layout(row, wrap)
              v-flex.md12.xs12
                v-text-field(label="Nome", color="gray", required, v-validate="'required'", :error-messages="errors.collect('texto')", data-vv-name="texto", data-vv-as="Texto", type="text", v-model='categoriaFeedbackAux.texto')
            v-layout(row, wrap)
              v-flex.xs12.text-xs-right
                v-btn(type="submit", color="bt-primary", :loading='loading').white--text Salvar

</template>

<script>
import _ from 'lodash';
import AccessLock from '@/components/AccessLock';

export default {
  components: {
    AccessLock
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    filter: { ativo: 1 },
    notificacoes: [],
    sortBy: 'id',
    sortDesc: false,
    headers: [
      { text: 'ID', align: 'left', value: 'id', sortable: false },
      { text: 'Título', align: 'left', value: 'titulo', sortable: false },
      { text: 'Conteúdo', align: 'left', value: 'descricao', sortable: false},
      { text: 'Data', align: 'left', value: 'data', sortable: false},
      { text: 'Tipo', align: 'left', value: 'tipo', sortable: false},
      { text: 'Status', align: 'left', value: 'status', sortable: false},
      { text: 'Ações', align: 'center',  sortable: false },
    ],
    search: '',
    loading: false,
    dialogCategoriaFeedback: false,
    categoriaFeedbackAux: {},
  }),
  computed: {
    list () {
      return _.filter(this.notificacoes, { ativo: this.filter.ativo });
    }
  },
  mounted () {
    this.getNotificacoes();
  },
  methods: {
    async getNotificacoes () {
      const vm = this;
      try {
        vm.loading = true;
        const response = await vm.$axios.get('/notificacao');
        vm.notificacoes = _.orderBy(response.data.rows, ['id', 'data_hora'], ['desc', 'asc']);
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async changeAtivo(categoria_feedback) {
      const vm = this;
      try {
        const obj = _.cloneDeep(categoria_feedback);
        obj.ativo = obj.ativo ? 0 : 1;
        const response = await vm.$axios.put(`/notificacao/${obj.id}`, obj);
        categoria_feedback.ativo = response.data.ativo;
        window.getApp.$emit('APP_ALERT', { color: obj.ativo ? 'success' : 'orange', text: `Categoria de feedback ${categoria_feedback.ativo ? 'ativada' : 'desativada'} com sucesso!` });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar a categoria de feedback. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    async save (categoria_feedback) {
      const vm = this;
      try {
        const response = await vm.$axios.post('/notificacao', categoria_feedback);
        categoria_feedback.id = response.data.id;
        vm.notificacoes.push(response.data);
        vm.loading = false;
        vm.dialogCategoriaFeedback = false;
        vm.categoriaFeedbackAux = {};
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Categoria de feedback salva com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar a categoria de feedback. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async update (categoria_feedback) {
      const vm = this;
      try {
        const response = await vm.$axios.put(`/notificacao/${categoria_feedback.id}`, categoria_feedback);
        const index = _.findIndex(vm.notificacoes, { id: categoria_feedback.id });
        const notificacoes = _.reject(vm.notificacoes, { id: categoria_feedback.id });
        vm.notificacoes = [...notificacoes.slice(0, index), response.data, ...notificacoes.slice(index)];
        vm.loading = false;
        vm.dialogCategoriaFeedback = false;
        vm.categoriaFeedbackAux = {};
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Categoria de feedback salvo com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao atualizar a categoria de feedback. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async salvar (scope) {
      const vm = this;
      try {
        vm.loading = true;  
        const result = await vm.$validator.validateAll();
        if (!result) throw 'Preencha todos os campos corretamente!';
        vm[vm.categoriaFeedbackAux.id ? 'update' : 'save'](vm.categoriaFeedbackAux);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        vm.loading = false;
      }
    },
    async openDialogCategoriaFeedback(categoria) {
      const vm = this;
      try {
        if (categoria && categoria.id) {
          vm.categoriaFeedbackAux = _.cloneDeep(categoria);
          const response = await vm.$axios.get(`/notificacao/${vm.categoriaFeedbackAux.id}`);
          vm.categoriaFeedbackAux = response.data || {};
        }
        vm.dialogCategoriaFeedback = true;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
  }
};
</script>

<style scoped>

</style>

